import { useMemo } from "react";

import { useGetOrders } from "@/api";
import type { GetOrdersParams } from "@/api/schemas/getOrdersParams";
import { GetOrdersOrder } from "@/api/schemas/getOrdersOrder";
import { GetOrdersSortBy } from "@/api/schemas/getOrdersSortBy";
import {
  parseOrderListResponse,
  type DashboardOrder,
} from "@/lib/validation/dashboard.schemas";
import { useSessionStore } from "@/stores/session.store";

export function useLatestOrders(limit = 8) {
  const activeStoreId = useSessionStore((state) => state.activeStoreId);

  const params = useMemo((): GetOrdersParams | undefined => {
    if (activeStoreId === null) return undefined;

    return {
      store_id: activeStoreId,
      per_page: limit,
      page: 1,
      sort_by: GetOrdersSortBy.createdAt,
      order: GetOrdersOrder.DESC,
    };
  }, [activeStoreId, limit]);

  const { data, isLoading, isError } = useGetOrders(params, {
    query: {
      enabled: activeStoreId !== null,
      select: (response): DashboardOrder[] =>
        parseOrderListResponse(response.data)?.data ?? [],
    },
  });

  return {
    orders: data ?? [],
    isLoading,
    isError,
  };
}
